// frontend/src/components/common/confirmVariants.jsx
import { ICON, CheckCircle, Info, Warning, WarningCircle } from '../../icons';

/** Every variant this dialog renders, and the two things a variant decides:
 *  the icon it leads with, and the MUI palette its filled confirm button
 *  takes. One map because the variant names also name the CSS classes
 *  (`confirm-dialog--danger`, ConfirmDialog.css), so a variant cannot be
 *  added to one of them alone.
 *
 *  No `color` here is ever 'inherit'. MUI paints a contained inherit button
 *  grey — grey[300] on a light theme, grey[800] on a dark one — and leaves
 *  `color: inherit`, so its label comes from whatever encloses it — no token
 *  governs it, and on a dark theme that is light text on light grey.
 *  styles/popupContrast.test.js measures every entry here. */
export const CONFIRM_VARIANTS = {
  danger: { icon: <WarningCircle size={ICON.xl} weight="regular" />, color: 'error' },
  warning: { icon: <Warning size={ICON.xl} weight="regular" />, color: 'primary' },
  info: { icon: <Info size={ICON.xl} weight="regular" />, color: 'primary' },
  success: { icon: <CheckCircle size={ICON.xl} weight="regular" />, color: 'primary' },
};
